// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f8Ll","questions":"styles_questions__2SFwG","footer":"styles_footer__3P1oW"};